export default __webpack_public_path__ + "static/media/default_user.7844a064.png";